"use client";

import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type SaveRollAnimationStore = {
  animationCount: number;
  incrementAnimationCount: () => void;
};

const SaveRollAnimationContext = createContext<SaveRollAnimationStore | null>(
  null
);

export function useSaveRollAnimation(): SaveRollAnimationStore {
  const ctx = useContext(SaveRollAnimationContext);
  if (!ctx) {
    throw new Error(
      "useSaveRollAnimation must be used within SaveRollAnimationProvider"
    );
  }
  return ctx;
}

export function SaveRollAnimationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [animationCount, setAnimationCount] = useState(0);
  const incrementAnimationCount = useCallback(() => {
    setAnimationCount((prev) => prev + 1);
  }, []);
  const value = useMemo(
    () => ({ animationCount, incrementAnimationCount }),
    [animationCount, incrementAnimationCount]
  );
  return (
    <SaveRollAnimationContext.Provider value={value}>
      {children}
    </SaveRollAnimationContext.Provider>
  );
}
